import { FC, PropsWithChildren } from "react";

import { FormType } from "@simplyk/common";

import { DonationFormV2Provider } from "./DonationFormV2Provider";
import { TicketingV2Provider } from "./TicketingV2Provider";

import { PreviewTicketingData } from "@/canvas/features/FormV2/hooks/useTicketingFormState";
import { FormStepKey } from "@/canvas/features/FormV2/steps/FormStepKey";
import { DonationFormFrontendPageOutput, TicketingFrontendPageOutput } from "@/common/types/trpc";

export type FormV2ProviderProps = {
  formObject: TicketingFrontendPageOutput | DonationFormFrontendPageOutput;
  currentStep: FormStepKey;
  setCurrentStep: (step: FormStepKey) => void;
  type: FormType.Ticketing | FormType.DonationForm;
  isEmbed: boolean;
  previewTicketingData?: PreviewTicketingData;
};

export const FormV2Provider: FC<PropsWithChildren<FormV2ProviderProps>> = ({
  children,
  type,
  formObject,
  currentStep,
  setCurrentStep,
  isEmbed,
  previewTicketingData,
}) => {
  if (type === FormType.Ticketing) {
    return (
      <TicketingV2Provider
        formObject={formObject as TicketingFrontendPageOutput}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        type={type}
        isEmbed={isEmbed}
        previewTicketingData={previewTicketingData}
      >
        {children}
      </TicketingV2Provider>
    );
  }

  return (
    <DonationFormV2Provider
      formObject={formObject as DonationFormFrontendPageOutput}
      currentStep={currentStep}
      setCurrentStep={setCurrentStep}
      type={type}
      isEmbed={isEmbed}
    >
      {children}
    </DonationFormV2Provider>
  );
};
